module.exports = __webpack_public_path__ + "static/group-image1-2da2a16cec74b997277a349d83446246.jpg";